module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/websocket/lib/version.js
// module id = 1793
// module chunks = 0